import moment from 'moment'
import axios from 'axios'
// state MUST be a function to support SSR
export const state = () => ({
  // 日程对话框
  scheduleDialog: {
    visible: false,
    method: '',
    no: ''
  },
  // 项目对话框
  projectDialog: {
    visible: false,
    method: '',
    no: ''
  },
  // 邀请成员对话框
  memberDialog: {
    visible: false,
    team_name: '',
    team_no: ''
  },
  // 日历是否需要刷新
  calanderRefresh: false,
  // 周报 or 月报
  reportType: '',
  reportStartTime: '',
  reportEndTime: '',
  // 当前选择时间
  selectDate: moment().format('YYYY-MM-DD HH:mm'),
  userInfo: {
    openid: '',
    role: '',
    telephone: '',
    user_no: '',
    username: ''
  },
  todayScheduleList: [],
  projectList: [],
  categoryList: [],
  remindTimeList: [],
  allScheduleList: [],
  taskNo: '' // 当前任务id
})
export const getters = {
  getProjectDialog (state) {
    return state.projectDialog
  },
  getScheduleDialog (state) {
    return state.scheduleDialog
  },
  getMemberDialog (state) {
    return state.memberDialog
  },
  getSelectDate (state) {
    return state.selectDate
  },
  getUserInfo (state) {
    return state.userInfo
  },
  getCategoryList (state) {
    return state.categoryList
  },
  getProjectList (state) {
    return state.projectList
  },
  getAllScheduleList (state) {
    return state.allScheduleList
  },
  getTaskNo (state) {
    return state.taskNo
  }
}
export const mutations = {
  setReportStartTime (state, newVal) {
    state.reportStartTime = newVal
  },
  setReportEndTime (state, newVal) {
    state.reportEndTime = newVal
  },
  setReportType (state, newVal) {
    state.reportType = newVal
  },
  setCalanderRefresh (state, newVal) {
    state.calanderRefresh = newVal
  },
  setScheduleDialog (state, newVal) {
    state.scheduleDialog = newVal
  },
  setMemberDialog (state, newVal) {
    state.memberDialog = newVal
  },
  setProjectDialog (state, newVal) {
    state.projectDialog = newVal
  },
  setSelectDate (state, newVal) {
    state.selectDate = newVal
  },
  setUserInfo (state, newVal) {
    console.log(newVal)
    state.userInfo = newVal
  },
  setCategoryList (state, newVal) {
    state.categoryList = newVal
  },
  setRemindTimeList (state, newVal) {
    state.remindTimeList = newVal
  },
  setProjectList (state, newVal) {
    state.projectList = newVal
  },
  setAllScheduleList (state, newVal) {
    state.allScheduleList = newVal
  },
  setTodayScheduleList (state, newVal) {
    state.todayScheduleList = newVal
  },
  setTaskNo (state, newVal) {
    state.taskNo = newVal
  }
}

export const actions = {
  setReportStartTime (context, data) {
    context.commit('setReportStartTime', data)
  },
  setReportEndTime (context, data) {
    context.commit('setReportEndTime', data)
  },
  setReportType (context, data) {
    context.commit('setReportType', data)
  },
  setCalanderRefresh (context, data) {
    context.commit('setCalanderRefresh', data)
  },
  setScheduleDialog (context, data) {
    context.commit('setScheduleDialog', data)
  },
  setProjectDialog (context, data) {
    context.commit('setProjectDialog', data)
  },
  setMemberDialog (context, data) {
    context.commit('setMemberDialog', data)
  },
  setSelectDate (context, date) {
    context.commit('setSelectDate', date)
  },
  setUserInfo (context, userInfo) {
    context.commit('setUserInfo', userInfo)
  },
  setCategoryList (context) {
    let _this = this._vm
    axios({
      type: 'get',
      url: _this.HOST + '/company/getCategory'
    }).then(function (response) {
      let data = response.data
      console.log('分类列表')
      console.log(data)
      if (data.statusCode === 200) {
        context.commit('setCategoryList', data.data)
      } else {
        console.log(data.message)
      }
    })
  },
  setRemindTimeList (context) {
    let _this = this._vm
    axios({
      type: 'get',
      url: _this.HOST + '/company/getRemindTimeList'
    }).then(function (response) {
      let data = response.data
      console.log('提醒列表')
      console.log(data)
      if (data.statusCode === 200) {
        context.commit('setRemindTimeList', data.data)
      } else {
        console.log(data.message)
      }
    })
  },
  setProjectList (context) {
    let _this = this._vm
    axios({
      type: 'get',
      url: _this.HOST + '/company/getTeamList',
      params: {
        user_no: this.state.userInfo.user_no
      }
    }).then(function (response) {
      let data = response.data
      console.log('项目列表')
      console.log(data)
      if (data.statusCode === 200) {
        context.commit('setProjectList', data.data)
      } else {
        console.log(data.message)
      }
    })
  },
  setTodayScheduleList (context) {
    let _this = this._vm
    axios({
      method: 'get',
      url: _this.HOST + '/task/getTodayTask',
      params: {
        user_no: this.state.userInfo.user_no,
        date_time: this.state.selectDate
      }
    }).then(function (response) {
      let data = response.data
      console.log('今日的日程')
      console.log(data)
      if (data.statusCode === 200) {
        context.commit('setTodayScheduleList', data.data)
      } else if (data.statusCode === 201) {
        console.log(data.message)
        context.commit('setTodayScheduleList', [])
      } else {
        console.log(data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  setAllScheduleList (context, obj = {}) {
    let _this = this._vm
    let start = moment().startOf('month').format('YYYY-MM-DD')
    let end = moment().endOf('month').format('YYYY-MM-DD')
    if (obj !== undefined && Object.keys(obj).length !== 0) {
      start = moment(obj.start).startOf('month').format('YYYY-MM-DD')
      end = moment(obj.end).endOf('month').format('YYYY-MM-DD')
    }
    console.log(start, end)
    axios({
      method: 'get',
      url: _this.HOST + '/task/getAllTask',
      params: {
        user_no: this.state.userInfo.user_no,
        start: start,
        end: end
      }
    }).then(function (response) {
      let data = response.data
      console.log('所有的日程')
      console.log(data)
      if (data.length === 0) {
        console.log('所有的日程为空')
      } else {
        context.commit('setAllScheduleList', data)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  setTaskNo (context, taskNo) {
    context.commit('setTaskNo', taskNo)
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/pc_store.js
// module id = null
// module chunks = 